<mat-dialog-content style="overflow-y: hidden">
  <div style="display: flex; justify-content: flex-end">
    <img
      (click)="closeDialog()"
      src="assets/images/icons/close.png"
      style="height: 16px; width: 16px; cursor: pointer"
    />
  </div>
  <div class="table-scroll-container">
    <table mat-table [dataSource]="savedInDraft" class="mat-elevation-z8">
      <ng-container matColumnDef="statementText" sticky>
        <th mat-header-cell *matHeaderCellDef>Statement Text</th>
      </ng-container>
      <ng-container matColumnDef="qualifier">
        <th mat-header-cell *matHeaderCellDef>Qualifier</th>
      </ng-container>

      <ng-container matColumnDef="marketingChannel">
        <th mat-header-cell *matHeaderCellDef>Marketing Channel</th>
      </ng-container>

      <ng-container matColumnDef="lifecycle">
        <th mat-header-cell *matHeaderCellDef>Lifecycle</th>
      </ng-container>

      <!-- <ng-container matColumnDef="pageTab">
        <th mat-header-cell *matHeaderCellDef>Page No</th>
      </ng-container>

      <ng-container matColumnDef="label">
        <th mat-header-cell *matHeaderCellDef>Label</th>
      </ng-container>

      <ng-container matColumnDef="label2">
        <th mat-header-cell *matHeaderCellDef>Level</th>
      </ng-container>

      <ng-container matColumnDef="level_model">
        <th mat-header-cell *matHeaderCellDef>Rule/Model Score(%)</th>
      </ng-container> -->

      <ng-container matColumnDef="manual_level">
        <th mat-header-cell *matHeaderCellDef>Manual Level</th>
      </ng-container>

      <!-- <ng-container matColumnDef="risk">
        <th mat-header-cell *matHeaderCellDef>Risk</th>
      </ng-container>

      <ng-container matColumnDef="risk_model">
        <th mat-header-cell *matHeaderCellDef>Rules/Model Score</th>
      </ng-container> -->

      <ng-container matColumnDef="manual_risk">
        <th mat-header-cell *matHeaderCellDef>Manual Risk</th>
      </ng-container>

      <!-- <ng-container matColumnDef="reason">
        <th mat-header-cell *matHeaderCellDef>Reason</th>
      </ng-container>

      <ng-container matColumnDef="reason_model">
        <th mat-header-cell *matHeaderCellDef>Rules/Model Score</th> 
      </ng-container>-->

      <ng-container matColumnDef="manual_reason">
        <th mat-header-cell *matHeaderCellDef>Manual Reason</th>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    </table>
    <div sticky class="section-label">Saved in Draft</div>

    <table mat-table [dataSource]="savedInDraft" class="mat-elevation-z8">
      <ng-container matColumnDef="statementText" sticky>
        <td mat-cell *matCellDef="let element">{{ element.text }}</td>
      </ng-container>
      <ng-container matColumnDef="qualifier">
        <td mat-cell *matCellDef="let element">
          <span
            [matTooltip]="element.qualifiers | safeHtml"
            [innerHTML]="element.qualifiers"
            >{{ element.qualifiers }}</span
          >
        </td>
      </ng-container>

      <ng-container matColumnDef="marketingChannel">
        <td
          mat-cell
          *matCellDef="let element"
          [matTooltip]="element.allMarketingChannels"
        >
          {{ element.allMarketingChannels }}
        </td>
      </ng-container>

      <!-- <ng-container matColumnDef="pageTab">
        <td mat-cell *matCellDef="let element">{{ element.page_no }}</td>
      </ng-container>

      <ng-container matColumnDef="label">
        <td mat-cell *matCellDef="let element">{{ element.Label }}</td>
      </ng-container>

      <ng-container matColumnDef="label2">
        <td mat-cell *matCellDef="let element">{{ element.level }}</td>
      </ng-container>

      <ng-container matColumnDef="level_model">
        <td mat-cell *matCellDef="let element">
          @if(element.level_model == 'By Rules' || element.level_model == " "){
          {{ element.level_model }}
          }@else {
          {{ element.level_model * 100 | number : "1.2-2" }}% }
        </td>
      </ng-container> -->

      <ng-container matColumnDef="lifecycle">
        <td mat-cell *matCellDef="let element">
          {{ element.text_lifecycles_UI }}
        </td>
      </ng-container>

      <ng-container matColumnDef="manual_level">
        <td mat-cell *matCellDef="let element">
          <!-- {{ getManualValues(element.manual_level) }} -->
          {{ element.manual_level }}
        </td>
      </ng-container>

      <!-- <ng-container matColumnDef="risk">
        <td class="risk_color" mat-cell *matCellDef="let element">
          <div *ngIf="element.level == 2">
            <span class="risk-0" *ngIf="element.risk == 1">Low</span>
            <span class="risk-1" *ngIf="element.risk == 2">Medium</span>
            <span class="risk-2" *ngIf="element.risk == 3">High</span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="risk_model">
        <td mat-cell *matCellDef="let element">
          @if(element.risk_model == 'By Rules' || element.risk_model == " "){
          {{ element.risk_model }}
          }@else {
          {{ element.risk_model * 100 | number : "1.2-2" }}% }
        </td>
      </ng-container> -->

      <ng-container matColumnDef="manual_risk">
        <td mat-cell *matCellDef="let element">
          <!-- {{ getManualValues(element.manual_risk) }} -->
          {{ element.manual_risk }}
        </td>
      </ng-container>

      <!-- <ng-container matColumnDef="reason">
        <td mat-cell *matCellDef="let element">
          @for(reason of element.reason;track reason){
          <div>{{ reason }}</div>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="reason_model">
        <td mat-cell *matCellDef="let element">
          @for(reason of element.reason_model;track reason){
          <div>{{ reason * 100 | number : "1.2-2" }}%</div>
          }
        </td>
      </ng-container> -->

      <ng-container matColumnDef="manual_reason">
        <td
          mat-cell
          *matCellDef="let element"
          [matTooltip]="element.manual_reason"
        >
          {{ element.manual_reason }}
        </td>
      </ng-container>

      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [ngClass]="{ 'odd-row': true }"
      ></tr>
    </table>

    <div class="section-label">Latest Updates</div>

    <table mat-table [dataSource]="latestUpdates" class="mat-elevation-z8">
      <ng-container matColumnDef="statementText" sticky>
        <td mat-cell *matCellDef="let element">{{ element.text }}</td>
      </ng-container>
      <ng-container matColumnDef="qualifier">
        <td mat-cell *matCellDef="let element">
          <span
            [matTooltip]="
              element.qualifier_veeva == 'NA'
                ? ''
                : (element.qualifier_veeva | safeHtml)
            "
            [innerHTML]="
              element.qualifier_veeva == 'NA' ? '' : element.qualifier_veeva
            "
            >{{
              element.qualifier_veeva == "NA" ? "" : element.qualifier_veeva
            }}</span
          >
        </td>
      </ng-container>

      <ng-container matColumnDef="marketingChannel">
        <td
          mat-cell
          *matCellDef="let element"
          [matTooltip]="
            element.marketing_channels_veeva == ''
              ? ''
              : element.marketing_channels_veeva
          "
        >
          {{
            element.marketing_channels_veeva == "NA"
              ? ""
              : element.marketing_channels_veeva
          }}
        </td>
      </ng-container>

      <!-- <ng-container matColumnDef="pageTab">
        <td mat-cell *matCellDef="let element">{{ element.page_no }}</td>
      </ng-container>

      <ng-container matColumnDef="label">
        <td mat-cell *matCellDef="let element">{{ element.Label }}</td>
      </ng-container>

      <ng-container matColumnDef="label2">
        <td mat-cell *matCellDef="let element">{{ element.level }}</td>
      </ng-container>

      <ng-container matColumnDef="level_model">
        <td mat-cell *matCellDef="let element">
          {{ element.level_model * 100 | number : "1.2-2" }}%
        </td>
      </ng-container> -->

      <ng-container matColumnDef="lifecycle">
        <td mat-cell *matCellDef="let element">
          {{ element.assessed_state }}
        </td>
      </ng-container>

      <ng-container matColumnDef="manual_level">
        <td mat-cell *matCellDef="let element">
          <!-- {{ getManualValues(element.manual_level) }} -->
          {{ element.manual_level_ui }}
        </td>
      </ng-container>

      <!-- <ng-container matColumnDef="risk">
        <td class="risk_color" mat-cell *matCellDef="let element">
          <div *ngIf="element.level == 2">
            <span class="risk-0" *ngIf="element.risk == 1">Low</span>
            <span class="risk-1" *ngIf="element.risk == 2">Medium</span>
            <span class="risk-2" *ngIf="element.risk == 3">High</span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="risk_model">
        <td mat-cell *matCellDef="let element">
          @if(element.risk_model == 'By rules' || element.risk_model == " "){
          {{ element.risk_model }}
          }@else {
          {{ element.risk_model * 100 | number : "1.2-2" }}% }
        </td>
      </ng-container> -->

      <ng-container matColumnDef="manual_risk">
        <td mat-cell *matCellDef="let element">
          <!-- {{ getManualValues(element.manual_risk) }} -->
          {{ element.manual_risk_ui }}
        </td>
      </ng-container>

      <!-- <ng-container matColumnDef="reason">
        <td mat-cell *matCellDef="let element">
          @for(reason of element.reason;track reason){
          <div>{{ reason }}</div>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="reason_model">
        <td mat-cell *matCellDef="let element">
          @for(reason of element.reason_model;track reason){
          <div>{{ reason * 100 | number : "1.2-2" }}%</div>
          }
        </td>
      </ng-container> -->

      <ng-container matColumnDef="manual_reason">
        <td
          mat-cell
          *matCellDef="let element"
          [matTooltip]="element.manual_reason_ui"
        >
          {{ element.manual_reason_ui }}
        </td>
      </ng-container>

      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="dialog-action">
  <button
    class="mat-button-decline"
    (click)="onDeclineLatestUpdates()"
    *ngIf="isDeclineEnabled()"
  >
    Decline Latest Updates
  </button>
  <button class="mat-button-latest" (click)="onAcceptLatestUpdates()">
    Accept Latest Updates
  </button>
</mat-dialog-actions>
